// import React from "react"
// import { useEffect } from "react"

// const TableComp = (props) => {
//     useEffect(() => {
//         console.log(props.data)
//     }, [props.data])

//     return (
//         <div className='w-full'>
//             {/* Mobile Card Layout */}
//             <div className='block lg:hidden'>
//                 <div className="space-y-3 p-2">
//                     {props.data?.length > 0 ? (
//                         props.data.map((rowData, index) => (
//                             <div key={index} className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
//                                 <div className="bg-gray-100 px-4 py-2 border-b border-gray-200">
//                                     <span className="text-sm font-semibold text-gray-800">Record #{index + 1}</span>
//                                 </div>
//                                 <div className="p-4">
//                                     <div className="space-y-3">
//                                         {rowData?.map((data, dataIndex) => (
//                                             <div key={dataIndex} className="flex flex-col sm:flex-row border-b border-gray-100 pb-2 last:border-b-0 last:pb-0">
//                                                 <div className="sm:w-1/3 mb-1 sm:mb-0">
//                                                     <span className="text-xs font-semibold text-gray-600 uppercase">
//                                                         {props.headers?.[dataIndex] || `Field ${dataIndex + 1}`}
//                                                     </span>
//                                                 </div>
//                                                 <div className="sm:w-2/3">
//                                                     <span className="text-sm text-gray-900">
//                                                         {data || '-'}
//                                                     </span>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             </div>
//                         ))
//                     ) : (
//                         <div className="text-center py-12 px-4 bg-white rounded-lg border border-gray-200">
//                             <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
//                                 <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                                 </svg>
//                             </div>
//                             <h3 className="text-lg font-semibold text-gray-900 mb-2">No Data Available</h3>
//                             <p className="text-gray-500">There are no records to display.</p>
//                         </div>
//                     )}
//                 </div>
//             </div>

//             {/* Desktop Table Layout - Clean Design like First Image */}
//             <div className='hidden lg:block w-full'>
//                 <div className='w-full bg-white rounded-lg overflow-hidden shadow-sm border border-gray-200'>
//                     <div className="overflow-x-auto">
//                         <table className="w-full min-w-full">
//                             {/* Clean Header - Matching First Image */}
//                             <thead>
//                                 <tr className="bg-gray-600 text-white">
//                                     {props.headers?.map((header, index) => (
//                                         <th 
//                                             key={index} 
//                                             className="px-6 py-3 text-left text-sm font-medium uppercase tracking-wide"
//                                             style={{ minWidth: '120px' }}
//                                         >
//                                             {header}
//                                         </th>
//                                     ))}
//                                 </tr>
//                             </thead>
                            
//                             {/* Clean Table Body */}
//                             <tbody className="bg-white divide-y divide-gray-200">
//                                 {props.data?.length > 0 ? (
//                                     props.data.map((rowData, index) => (
//                                         <tr 
//                                             key={index} 
//                                             className={`hover:bg-gray-50 transition-colors ${
//                                                 index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
//                                             }`}
//                                         >
//                                             {rowData?.map((data, dataIndex) => (
//                                                 <td 
//                                                     key={dataIndex} 
//                                                     className="px-6 py-4 text-sm text-gray-900"
//                                                     style={{ minWidth: '120px' }}
//                                                 >
//                                                     <div  title={data || 'No data'}>
//                                                         {data || '-'}
//                                                     </div>
//                                                 </td>
//                                             ))}
//                                         </tr>
//                                     ))
//                                 ) : (
//                                     <tr>
//                                         <td 
//                                             colSpan={props.headers?.length || 1} 
//                                             className="px-6 py-12 text-center text-gray-500"
//                                         >
//                                             <div className="flex flex-col items-center space-y-3">
//                                                 <svg className="w-12 h-12 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                                                 </svg>
//                                                 <div>
//                                                     <h3 className="text-lg font-medium text-gray-900">No Data Available</h3>
//                                                     <p className="text-sm text-gray-500 mt-1">There are no records to display.</p>
//                                                 </div>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             </div>

//             {/* Simple Styles */}
//             <style jsx>{`
//                 /* Custom scrollbar */
//                 .overflow-x-auto::-webkit-scrollbar {
//                     height: 6px;
//                 }

//                 .overflow-x-auto::-webkit-scrollbar-track {
//                     background: #f1f5f9;
//                 }

//                 .overflow-x-auto::-webkit-scrollbar-thumb {
//                     background: #cbd5e1;
//                     border-radius: 3px;
//                 }

//                 .overflow-x-auto::-webkit-scrollbar-thumb:hover {
//                     background: #94a3b8;
//                 }

//                 /* Table hover effects */
//                 tbody tr:hover {
//                     box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
//                 }

//                 /* Text truncation */
//                 .truncate {
//                     white-space: nowrap;
//                     overflow: hidden;
//                     text-overflow: ellipsis;
//                     max-width: 200px;
//                 }
//             `}</style>
//         </div>
//     )
// }

// export default TableComp


import React, { useEffect, useState } from "react";

const TableComp = (props) => {
    const [showTrackDetails, setShowTrackDetails] = useState(null);
    const [showChannelDetails, setShowChannelDetails] = useState(null);

    useEffect(() => {
        // console.log("TableComp props.data:", props.data);
        // console.log("TableComp channelDetailsData:", props.channelDetailsData);
    }, [props.data, props.channelDetailsData]);

    const handleTrackDetailsClick = (index) => {
        setShowTrackDetails(showTrackDetails === index ? null : index);
        setShowChannelDetails(null);
    };

    const handleChannelDetailsClick = (index) => {
        setShowChannelDetails(showChannelDetails === index ? null : index);
        setShowTrackDetails(null);
        // console.log("Channel Details Data at index", index, ":", props.channelDetailsData?.[index]?.distributionChannel);
    };

    return (
        <div className='w-full'>
            <div className='block lg:hidden'>
                <div className="space-y-3 p-2">
                    {props.data?.length > 0 ? (
                        props.data.map((rowData, index) => (
                            <div key={index} className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
                                <div className="bg-gray-100 px-4 py-2 border-b border-gray-200">
                                    <span className="text-sm font-semibold text-gray-800">Record #{index + 1}</span>
                                </div>
                                <div className="p-4">
                                    <div className="space-y-3">
                                        {rowData?.map((data, dataIndex) => (
                                            <div key={dataIndex} className="flex flex-col sm:flex-row border-b border-gray-100 pb-2 last:border-b-0 last:pb-0">
                                                <div className="sm:w-1/3 mb-1 sm:mb-0">
                                                    <span className="text-xs font-semibold text-gray-600 uppercase">
                                                        {props.headers?.[dataIndex] || `Field ${dataIndex + 1}`}
                                                    </span>
                                                </div>
                                                <div className="sm:w-2/3 relative">
                                                    {props.headers[dataIndex] === "Track Details" ? (
                                                        <>
                                                            <button
                                                                onClick={() => handleTrackDetailsClick(index)}
                                                                className="text-sm text-blue-600 hover:text-blue-800"
                                                            >
                                                                {data}
                                                            </button>
                                                            {showTrackDetails === index && (
                                                                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                                                    <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-6 max-h-96 overflow-y-auto scrollbar-custom max-w-md w-full mx-4">
                                                                        <div className="flex justify-between items-center mb-4">
                                                                            <h4 className="text-lg font-semibold text-gray-800">Track Details</h4>
                                                                            <button
                                                                                onClick={() => setShowTrackDetails(null)}
                                                                                className="text-gray-400 hover:text-gray-600"
                                                                            >
                                                                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                                                </svg>
                                                                            </button>
                                                                        </div>
                                                                        {props.trackDetailsData?.[index]?.trackDetails?.length > 0 ? (
                                                                            props.trackDetailsData[index].trackDetails.map((track, trackIndex) => (
                                                                                <div key={trackIndex} className="border-b border-gray-100 py-3 last:border-b-0">
                                                                                    <p className="text-sm text-gray-900 mb-1"><strong>Track Name:</strong> {track.DisplayTitle || '-'}</p>
                                                                                    <p className="text-sm text-gray-900 mb-1"><strong>Album Name:</strong> {track.AlbumTitle || '-'}</p>
                                                                                    <p className="text-sm text-gray-900"><strong>Length:</strong> {track.Length || '-'}</p>
                                                                                </div>
                                                                            ))
                                                                        ) : props.trackDetailsData?.[index]?.trackIds?.length > 0 ? (
                                                                            props.trackDetailsData[index].trackIds.map((track, trackIndex) => {
                                                                                const copyrightInfo = track.copyrightInfo?.split('\n').reduce((acc, line) => {
                                                                                    const [key, value] = line.split(':').map(s => s.trim());
                                                                                    if (key && value) acc[key] = value;
                                                                                    return acc;
                                                                                }, {}) || {};
                                                                                return (
                                                                                    <div key={trackIndex} className="border-b border-gray-100 py-3 last:border-b-0">
                                                                                        <p className="text-sm text-gray-900 mb-1"><strong>Track Name:</strong> {copyrightInfo.DisplayTitle || '-'}</p>
                                                                                        <p className="text-sm text-gray-900 mb-1"><strong>Album Name:</strong> {copyrightInfo.AlbumTitle || '-'}</p>
                                                                                        <p className="text-sm text-gray-900"><strong>Length:</strong> {copyrightInfo.Length || '-'}</p>
                                                                                    </div>
                                                                                );
                                                                            })
                                                                        ) : (
                                                                            <p className="text-sm text-gray-500 text-center py-4">No track details available</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : props.headers[dataIndex] === "Distribution Channel" ? (
                                                        <>
                                                            <button
                                                                onClick={() => handleChannelDetailsClick(index)}
                                                                className="text-sm text-blue-600 hover:text-blue-800"
                                                                disabled={data === '-'}
                                                            >
                                                                {data}
                                                            </button>
                                                            {showChannelDetails === index && (
                                                                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                                                    <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-6 max-h-96 overflow-y-auto scrollbar-custom max-w-md w-full mx-4">
                                                                        <div className="flex justify-between items-center mb-4">
                                                                            <h4 className="text-lg font-semibold text-gray-800">Distribution Channels</h4>
                                                                            <button
                                                                                onClick={() => setShowChannelDetails(null)}
                                                                                className="text-gray-400 hover:text-gray-600"
                                                                            >
                                                                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                                                </svg>
                                                                            </button>
                                                                        </div>
                                                                        {props.channelDetailsData?.[index]?.distributionChannel && typeof props.channelDetailsData[index].distributionChannel === 'object' && Object.keys(props.channelDetailsData[index].distributionChannel).length > 0 ? (
                                                                            Object.entries(props.channelDetailsData[index].distributionChannel).map(([channel, urls], channelIndex) => (
                                                                                <div key={channelIndex} className="border-b border-gray-100 py-3 last:border-b-0">
                                                                                    <p className="text-sm text-gray-900 mb-1"><strong>{channel}:</strong></p>
                                                                                    {Array.isArray(urls) && urls.length > 0 ? (
                                                                                        urls.map((url, urlIndex) => (
                                                                                            <p key={urlIndex} className="text-sm text-blue-600 hover:underline">
                                                                                                <a href={url} target="_blank" rel="noopener noreferrer">{url}</a>
                                                                                            </p>
                                                                                        ))
                                                                                    ) : (
                                                                                        <p className="text-sm text-gray-500">No URLs available</p>
                                                                                    )}
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                            <p className="text-sm text-gray-500 text-center py-4">No distribution channels available</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <span className="text-sm text-gray-900">
                                                            {data || '-'}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center py-12 px-4 bg-white rounded-lg border border-gray-200">
                            <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
                                <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">No Data Available</h3>
                            <p className="text-gray-500">There are no records to display.</p>
                        </div>
                    )}
                </div>
            </div>
            <div className='hidden lg:block w-full relative'>
                <div className='w-full bg-white rounded-lg overflow-hidden shadow-sm border border-gray-200'>
                    <div className="overflow-x-auto">
                        <table className="w-full min-w-full">
                            <thead>
                                <tr className="bg-gray-600 text-white">
                                    {props.headers?.map((header, index) => (
                                        <th
                                            key={index}
                                            className="px-6 py-3 text-left text-sm font-medium uppercase tracking-wide"
                                            style={{ minWidth: '120px' }}
                                        >
                                            {header}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {props.data?.length > 0 ? (
                                    props.data.map((rowData, index) => (
                                        <tr
                                            key={index}
                                            className={`hover:bg-gray-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
                                        >
                                            {rowData?.map((data, dataIndex) => (
                                                <td
                                                    key={dataIndex}
                                                    className="px-6 py-4 text-sm text-gray-900"
                                                    style={{ minWidth: '120px' }}
                                                >
                                                    {props.headers[dataIndex] === "Track Details" ? (
                                                        <button
                                                            onClick={() => handleTrackDetailsClick(index)}
                                                            className="text-blue-600 hover:text-blue-800 underline"
                                                        >
                                                            {data}
                                                        </button>
                                                    ) : props.headers[dataIndex] === "Distribution Channel" ? (
                                                        <button
                                                            onClick={() => handleChannelDetailsClick(index)}
                                                            className="text-blue-600 hover:text-blue-800 underline"
                                                            disabled={data === '-'}
                                                        >
                                                            {data}
                                                        </button>
                                                    ) : (
                                                        <div title={data || 'No data'}>
                                                            {data || '-'}
                                                        </div>
                                                    )}
                                                </td>
                                            ))}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan={props.headers?.length || 1}
                                            className="px-6 py-12 text-center text-gray-500"
                                        >
                                            <div className="flex flex-col items-center space-y-3">
                                                <svg className="w-12 h-12 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                </svg>
                                                <div>
                                                    <h3 className="text-lg font-medium text-gray-900">No Data Available</h3>
                                                    <p className="text-sm text-gray-500 mt-1">There are no records to display.</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                {showTrackDetails !== null && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white border border-gray-200 rounded-lg shadow-xl p-6 max-h-96 overflow-y-auto scrollbar-custom max-w-lg w-full mx-4">
                            <div className="flex justify-between items-center mb-4">
                                <h4 className="text-lg font-semibold text-gray-800">Track Details</h4>
                                <button
                                    onClick={() => setShowTrackDetails(null)}
                                    className="text-gray-400 hover:text-gray-600 p-1"
                                >
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                            <div className="space-y-4">
                                {props.trackDetailsData?.[showTrackDetails]?.trackDetails?.length > 0 ? (
                                    props.trackDetailsData[showTrackDetails].trackDetails.map((track, trackIndex) => (
                                        <div key={trackIndex} className="border-b border-gray-100 pb-4 last:border-b-0 last:pb-0">
                                            <div className="space-y-2">
                                                <p className="text-sm text-gray-900"><strong>Track Name:</strong> {track.DisplayTitle || '-'}</p>
                                                <p className="text-sm text-gray-900"><strong>Album Name:</strong> {track.AlbumTitle || '-'}</p>
                                                <p className="text-sm text-gray-900"><strong>Length:</strong> {track.Length || '-'}</p>
                                            </div>
                                        </div>
                                    ))
                                ) : props.trackDetailsData?.[showTrackDetails]?.trackIds?.length > 0 ? (
                                    props.trackDetailsData[showTrackDetails].trackIds.map((track, trackIndex) => {
                                        const copyrightInfo = track.copyrightInfo?.split('\n').reduce((acc, line) => {
                                            const [key, value] = line.split(':').map(s => s.trim());
                                            if (key && value) acc[key] = value;
                                            return acc;
                                        }, {}) || {};
                                        return (
                                            <div key={trackIndex} className="border-b border-gray-100 pb-4 last:border-b-0 last:pb-0">
                                                <div className="space-y-2">
                                                    <p className="text-sm text-gray-900"><strong>Track Name:</strong> {copyrightInfo.DisplayTitle || '-'}</p>
                                                    <p className="text-sm text-gray-900"><strong>Album Name:</strong> {copyrightInfo.AlbumTitle || '-'}</p>
                                                    <p className="text-sm text-gray-900"><strong>Length:</strong> {copyrightInfo.Length || '-'}</p>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <p className="text-sm text-gray-500 text-center py-4">No track details available</p>
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {showChannelDetails !== null && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white border border-gray-200 rounded-lg shadow-xl p-6 max-h-96 overflow-y-auto scrollbar-custom max-w-lg w-full mx-4">
                            <div className="flex justify-between items-center mb-4">
                                <h4 className="text-lg font-semibold text-gray-800">Distribution Channels</h4>
                                <button
                                    onClick={() => setShowChannelDetails(null)}
                                    className="text-gray-400 hover:text-gray-600 p-1"
                                >
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                            <div className="space-y-4">
                                {props.channelDetailsData?.[showChannelDetails]?.distributionChannel && typeof props.channelDetailsData[showChannelDetails].distributionChannel === 'object' && Object.keys(props.channelDetailsData[showChannelDetails].distributionChannel).length > 0 ? (
                                    Object.entries(props.channelDetailsData[showChannelDetails].distributionChannel).map(([channel, urls], channelIndex) => (
                                        <div key={channelIndex} className="border-b border-gray-100 pb-4 last:border-b-0 last:pb-0">
                                            <p className="text-sm text-gray-900 mb-1"><strong>{channel}:</strong></p>
                                            {Array.isArray(urls) && urls.length > 0 ? (
                                                urls.map((url, urlIndex) => (
                                                    <p key={urlIndex} className="text-sm text-blue-600 hover:underline">
                                                        <a href={url} target="_blank" rel="noopener noreferrer">{url}</a>
                                                    </p>
                                                ))
                                            ) : (
                                                <p className="text-sm text-gray-500">No URLs available</p>
                                            )}
                                        </div>
                                    ))
                                ) : (
                                    <p className="text-sm text-gray-500 text-center py-4">No distribution channels available</p>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <style jsx>{`
                .overflow-x-auto::-webkit-scrollbar {
                    height: 6px;
                }
                .overflow-x-auto::-webkit-scrollbar-track {
                    background: #f1f5f9;
                }
                .overflow-x-auto::-webkit-scrollbar-thumb {
                    background: #cbd5e1;
                    border-radius: 3px;
                }
                .overflow-x-auto::-webkit-scrollbar-thumb:hover {
                    background: #94a3b8;
                }
                .scrollbar-custom::-webkit-scrollbar {
                    width: 6px;
                }
                .scrollbar-custom::-webkit-scrollbar-track {
                    background: #f1f5f9;
                }
                .scrollbar-custom::-webkit-scrollbar-thumb {
                    background: #cbd5e1;
                    border-radius: 3px;
                }
                .scrollbar-custom::-webkit-scrollbar-thumb:hover {
                    background: #94a3b8;
                }
                tbody tr:hover {
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                }
                .truncate {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 200px;
                }
                .modal-backdrop {
                    backdrop-filter: blur(2px);
                }
            `}</style>
        </div>
    );
};

export default TableComp;